<template>
  <div class="ct-form-wrap" v-if="citeResults">
    <div class="ct-reference-list" :class="{open : openList}">
      <button class="reference-title" @click="openList = !openList">
        <h6>Reference List</h6>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g>
            <path fill="none" d="M0 0H24V24H0z" transform="rotate(180 12 12)"/>
            <path fill="#2659a8" d="M10.307 11.76L14.56 16l4.253-4.244 1.307 1.307-5.56 5.56L9 13.067z" transform="rotate(180 12 12) translate(-3.001 -2.76)"/>
          </g>
        </svg>
      </button>

      <ul>
        <li v-for="(item, idx) in citeResults">
          <div class="reference-box">
            <div class="reference-top">
              <div class="badge-box">
                <span class="ct-badge">{{item.style}}</span>
                <span class="ct-badge">{{$t(`source-${item.source}`)}}</span>
              </div>
              <div class="link-box">
                <!-- link-copy -->
                <button type="button" class="link" title="Copy" v-on:click="citeCopy(`result${idx}`)">
                  <svg xmlns="http://www.w3.org/2000/svg" id="icon_paste" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="#ececec" d="M4 0h16a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"/>
                    <g fill="#ececec" transform="translate(19948 -5339)">
                      <g>
                        <path d="M10 10H1V1h9v9z" class="cls-4" transform="translate(-19940 5344)"/>
                        <path fill="#9c9c9c" d="M2 2v7h7V2H2M0 0h11v11H0V0z" transform="translate(-19940 5344)"/>
                      </g>
                      <g stroke="#9c9c9c" stroke-width="2px">
                        <path d="M0 0H11V11H0z" class="cls-4" transform="translate(-19943 5347)"/>
                        <path fill="none" d="M1 1H10V10H1z" transform="translate(-19943 5347)"/>
                      </g>
                    </g>
                  </svg>
                </button>
                <!-- link-delete -->
                <button type="button" class="link" title="Delete" v-on:click="deleteCiteData(idx)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <g>
                      <g transform="translate(-1496 -781) translate(1496 781)">
                        <rect width="24" height="24" fill="#ffe5e5" rx="4"/>
                        <path fill="#f80003" d="M0 0H2V14H0z" transform="rotate(90 4 15)"/>
                      </g>
                    </g>
                  </svg>
                </button>
              </div>
            </div>
            <p v-html="item.result" :id="`result${idx}`"></p>
            <div :id="`result${idx}_copy`"></div>
          </div>
        </li>
      </ul>
    </div>

    <CommonModal v-bind:text="this.modalContent" v-if="showModal" v-on:close="showModal=false"/>

  </div>
</template>

<script>
import reverse from "lodash/reverse";
import cloneDeep from "lodash/cloneDeep";
import CommonModal from '@/components/CommonModal';

export default {
  name: "CiteResults",
  components: {
    'CommonModal' : CommonModal,
  },
  data: function () {
    return {
      openList: false,
      showModal: false,
      modalContent : '',
    }
  },
  computed: {
    citeResults() {
      if( this.$store.state.cite.length > 0 ) {
        this.openList = true;
        return reverse(cloneDeep(this.$store.state.cite)); // 최신이 위로 오게
      }
      else{
        return null;
      }
    }
  },
  methods: {
    citeCopy(element_id){
      let aux = document.createElement('div');
      let copy_id = element_id+'_copy';
      aux.setAttribute('contentEditable', 'true');
      aux.innerHTML = document.getElementById(element_id).innerHTML;
      aux.setAttribute("onfocus", "document.execCommand('selectAll',false,null)");
      //document.body.appendChild(aux);
      document.getElementById(copy_id).appendChild(aux);
      aux.focus();
      document.execCommand("copy");

      this.showCommonModal(this.$t('copied_messgage'));
      document.getElementById(copy_id).removeChild(aux);
    },

    deleteCiteData (index) {
      // 저장 LIST에 출력이 거꾸로 되기 때문에 index도 reverse
      // 5개가 저장 되어 있다면 첫번째 리스트 삭제 요청 -> index 4를 지워야함.
      const length = this.$store.state.cite.length;
      index += 1;
      this.$store.commit('delete_cite', length-index);
    },

    showCommonModal (txt){
      //show Modal
      this.showModal = true;
      this.modalContent = txt;
      document.body.classList.add("modal-open");
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/generator/CiteResults.vue